<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-back-button slot="start"></ion-back-button>
    <ion-title>View Master Template</ion-title>
    <ion-button slot="end" fill="clear" (click)="editTemplate()"
      >Edit</ion-button
    >
  </ion-toolbar>
</ion-header>

<ion-content>
 <div sxCol sxGap="10px" sxPadding="medium">

   <ion-item lines="none" sxRadius="small">
     <ion-label>Master Template Name
       <span sxTextWeight="bold">{{ masterTemplate?.template?.purpose }}</span></ion-label>
     <ion-button
       slot="end"
       (click)="deleteTemplate(masterTemplate?._id)"
       fill="clear">
       <ion-icon name="trash-outline"></ion-icon>
     </ion-button>
   </ion-item>


   <ion-list *ngIf="masterTemplate">
     <ion-list-header> Required IDs </ion-list-header>
     <ion-item *ngFor="let id of masterTemplate.template.acceptedIds">
       <ion-label>{{ id.name }}</ion-label>
       <ion-note slot="end">{{id.isMandatory ? 'Required' : 'Optional'}}</ion-note>
     </ion-item>
   </ion-list>


 </div>
</ion-content>
